<div [@slideInOut]="!!isClosed">
  <table class="exnpanding-table">
    <tbody style="min-width: 1360px" style="padding: 8px 0 !important">
      <ng-container *ngFor="let endpoint of endpoints; let i = index">
        <tr class="table-row">
          <td style="width: 40px !important"></td>
          <td style="width: 90px !important">
            <nz-switch
              (ngModelChange)="
                onChangeActiveEndpoint($event, endpoint.id, side)
              "
              [(ngModel)]="endpoint.active"
              [nzDisabled]="isDisabledSwitch(endpoint)"
            ></nz-switch>
          </td>
          <td style="width: 90px !important">{{ endpoint.id }}</td>
          <td style="width: 230px !important">
            <button
              nz-button
              nzType="text"
              [disabled]="!filterLists.length"
              class="end-name"
              nz-tooltip
              nzTooltipTitle="{{ endpoint.name }}"
              nzTooltipPlacement="top"
              *ngIf="side === 'ssp'; else dspModalTemplate"
              (click)="openSspEditModal(endpoint.id, endpoint.companyId)"
              [name]="endpoint.name"
            >
              {{ endpoint.name | trunc : [20] }}
            </button>
            <ng-template #dspModalTemplate>
              <button
                nz-button
                nzType="text"
                [disabled]="!filterLists.length"
                class="end-name"
                nz-tooltip
                nzTooltipTitle="{{ endpoint.name }}"
                nzTooltipPlacement="top"
                (click)="openDspEditModal(endpoint.id, endpoint.companyId)"
                [name]="endpoint.name"
              >
                {{ endpoint.name | trunc : [20] }}
              </button>
            </ng-template>
          </td>
          <td
            *ngIf="isOptionActive('type', side)"
            style="width: 90px !important"
          >
            {{ connectionTypes[endpoint.connectionType] }}
          </td>
          <td
            *ngIf="isOptionActive('formats', side)"
            style="width: 200px !important"
          >
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.banner"
              [src]="'/assets/img/formats/banner.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Banner"
              nzTooltipPlacement="top"
            />
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.native"
              [src]="'/assets/img/formats/native.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Native"
              nzTooltipPlacement="top"
            />
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.video"
              [src]="'/assets/img/formats/video.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Video"
              nzTooltipPlacement="top"
            />
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.pop"
              [src]="'/assets/img/formats/pop.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Pop"
              nzTooltipPlacement="top"
            />
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.push"
              [src]="'/assets/img/formats/push.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Push"
              nzTooltipPlacement="top"
            />
            <img
              class="icon--formats"
              *ngIf="endpoint.formats.audio"
              [src]="'/assets/img/formats/audio.svg'"
              alt=""
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              nzTooltipTitle="Audio"
              nzTooltipPlacement="top"
            />
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('incoming_qps', side)"
            style="width: 180px !important"
          >
            {{ endpoint.incoming_qps }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('qps', side)"
            style="width: 110px !important"
          >
            {{ endpoint.qps }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('limitQPS', side)"
            style="width: 140px !important"
          >
            {{ endpoint.limitQPS }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('bidqps', side)"
            style="width: 140px !important"
          >
            {{ endpoint.bidqps }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('realQPS', side)"
            style="width: 140px !important"
          >
            {{ endpoint.realQPS }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('daylySpend', side)"
            style="width: 180px !important"
          >
            {{
              currencyPipe.transform(
                endpoint.daylySpend,
                "USD",
                "symbol",
                ".0-5"
              )
            }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('bidQPS', side)"
            style="width: 110px !important"
          >
            {{ endpoint.bidQPS }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('yesterdaySpend', side)"
            style="width: 180px !important"
          >
            {{
              currencyPipe.transform(
                endpoint.yesterdaySpend,
                "USD",
                "symbol",
                ".0-5"
              )
            }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('ssp_ecpm', side)"
            style="width: 180px !important"
          >
            {{ endpoint.ssp_ecpm }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('ssp_rcpm', side)"
            style="width: 180px !important"
          >
            {{ endpoint.ssp_rcpm }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('valid_bid_rate', side)"
            style="width: 200px !important"
          >
            {{ endpoint.valid_bid_rate }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('daylySpend', side)"
            style="width: 140px !important"
          >
            {{
              currencyPipe.transform(
                endpoint.daylySpend,
                "USD",
                "symbol",
                ".0-5"
              )
            }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('win_rate', side)"
            style="width: 150px !important"
          >
            {{ endpoint.win_rate }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('yesterdaySpend', side)"
            style="width: 180px !important"
          >
            {{
              currencyPipe.transform(
                endpoint.yesterdaySpend,
                "USD",
                "symbol",
                ".0-5"
              )
            }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('dsp_ecpm', side)"
            style="width: 180px !important"
          >
            {{ endpoint.dsp_ecpm }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('dsp_rcpm', side)"
            style="width: 180px !important"
          >
            {{ endpoint.dsp_rcpm }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('total_bid_rate', side)"
            style="width: 200px !important"
          >
            {{ endpoint.total_bid_rate }}
          </td>
          <td
            *ngIf="side === 'ssp' && isOptionActive('render_rate', side)"
            style="width: 170px !important"
          >
            {{ endpoint.render_rate }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('win_rate', side)"
            style="width: 150px !important"
          >
            {{ endpoint.win_rate }}
          </td>
          <td
            *ngIf="isOptionActive('fill_rate', side)"
            style="width: 130px !important"
          >
            {{ endpoint.fill_rate }}
          </td>
          <td
            *ngIf="isOptionActive('spendLimit', side)"
            style="width: 170px !important"
          >
            {{ endpoint.spendLimit }}
          </td>
          <td
            *ngIf="isOptionActive('margin', side)"
            style="width: 130px !important"
          >
            {{ getMargin(endpoint) }}
          </td>
          <td
            *ngIf="isOptionActive('region', side)"
            style="width: 130px !important"
          >
            {{ endpoint.region }}
          </td>
          <td
            *ngIf="side === 'dsp' && isOptionActive('nurl', side)"
            style="width: 160px !important"
          >
            {{ endpoint.nurl }}
          </td>
          <td
            *ngIf="isOptionActive('email', side)"
            style="width: 130px !important"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="endpoint.email"
            nzTooltipPlacement="top"
          >
            {{ endpoint.email | trunc : [15] }}
          </td>
          <td
            *ngIf="isOptionActive('comments', side)"
            style="width: 115px !important"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="endpoint.comments"
            nzTooltipPlacement="top"
          >
            {{ endpoint.comments | trunc : [10] }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
